import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MongoAssortment } from '../../models/mongo-assortment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class MongoAssortmentService {
  private mongoAssortmentSubject: BehaviorSubject<MongoAssortment[]>;
  baseUrl = 'json/mongo-assortments';

  constructor(protected http: HttpClient) {}

  public getOne(id: string, nocache?: boolean): Observable<MongoAssortment> {
    const headers = {
      maxAge: nocache ? '-1' : '300'
    };
    const url = `${this.baseUrl}/${id}`;
    return this.http.get<MongoAssortment>(url, { headers });
  }

  public getAll(nocache?: boolean): Observable<MongoAssortment[]> {
    if (!this.mongoAssortmentSubject) {
      this.mongoAssortmentSubject = new BehaviorSubject<MongoAssortment[]>([]);
      this.updateSubject(nocache);
    }
    return this.mongoAssortmentSubject.asObservable();
  }

  public create(bookmark: MongoAssortment): Observable<MongoAssortment> {
    return this.http.post<MongoAssortment>(this.baseUrl, bookmark).pipe(tap(_ => this.updateSubject(true)));
  }

  public deleteById(id: string): Observable<void> {
    const url = `${this.baseUrl}/${id}`;
    return this.http.delete<void>(url).pipe(tap(_ => this.updateSubject(true)));
  }

  updateSubject(nocache?: boolean): void {
    this.internalGetAll(nocache).subscribe(pb => {
      if (!!this.mongoAssortmentSubject) {
        this.mongoAssortmentSubject.next(pb);
      }
    });
  }

  protected internalGetAll(nocache?: boolean): Observable<MongoAssortment[]> {
    const headers = {
      maxAge: nocache ? '-1' : '300'
    };
    return this.http.get<MongoAssortment[]>(this.baseUrl, { headers });
  }
}
